var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoAllergy(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/filled/uniq/check_allergy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/filled/uniq/check_allergy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico_allergy",
    transform: "translate(8.000000, 1.000000)",
    fill: "#E74C3C",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6235812,1.61941406 L10.6235812,3.78442188 L6.68834693,5.89346875 L6.68834693,0 L5.31198313,0 L5.31198313,5.89346875 L1.37674888,3.78442188 L1.37674888,1.61941406 L0,1.61941406 L0,17.8030937 L5.31203814,20.6500937 L5.31203814,25.6625078 L5.31203814,26 L6.68840194,26 L6.68840194,25.6625586 L6.68840194,20.6501445 L12,17.8031445 L12,1.61941406 L10.6235812,1.61941406 Z M5.31203814,19.1804844 L1.37680389,17.0714375 L1.37680389,14.1121094 L5.31203814,16.2215625 L5.31203814,19.1804844 Z M5.31203814,14.7519023 L1.37680389,12.6424492 L1.37680389,9.68307031 L5.31203814,11.7925234 L5.31203814,14.7519023 Z M5.31203814,10.3229141 L1.37680389,8.21346094 L1.37680389,5.25408203 L5.31203814,7.36312891 L5.31203814,10.3229141 Z M10.6235812,17.0714883 L6.68834693,19.1805352 L6.68834693,16.2215625 L10.6235812,14.1121094 L10.6235812,17.0714883 Z M10.6235812,12.6424492 L6.68834693,14.7519023 L6.68834693,11.7925234 L10.6235812,9.68307031 L10.6235812,12.6424492 Z M10.6235812,8.21346094 L6.68834693,10.3229141 L6.68834693,7.36312891 L10.6235812,5.25408203 L10.6235812,8.21346094 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoAllergy);
export default __webpack_public_path__ + "static/media/ico_allergy.50a4d6b307792d13cd0f3bb14df35645.svg";
export { ForwardRef as ReactComponent };